import { HOTO_SITE,GO_LIVE_FILTER,HOTO_ENG_SITE,HOTO_MATERIAL_LIST,HOTO_DETAILS,HOTO_ALL_DETAILS } from "./type";

const initalState = {
  hotoSiteData: {},
  liveFilterDropDown: {},
  hotoEngSiteData: {},
  hotoMaterialList: {},
  hotoDetails:{},
  hotoAllDetails: {}
};

const HotoReducer = (state = initalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case HOTO_SITE:
      return {
        ...state,
        hotoSiteData: payload,
      };
    case GO_LIVE_FILTER:
      return {
        ...state,
        liveFilterDropDown: payload,
      };
    case HOTO_ENG_SITE:
      return {
        ...state,
        hotoEngSiteData: payload,
      };
    case HOTO_MATERIAL_LIST:
      return {
        ...state,
        hotoMaterialList: payload,
      };
    case HOTO_DETAILS :
      return {
        ...state,
        hotoDetails: payload
      }
    case HOTO_ALL_DETAILS :
      return {
        ...state,
        hotoAllDetails: payload
      }
    default:
      return {
        ...state,
      };
  }
};

export default HotoReducer;
